import React from 'react';

class FilterColor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_type: props.filter_type,
      filter_color: props.filter_color,
    };
  }

  shouldComponentUpdate(nextProps) {
    const bg = document.querySelector('#hu-filter .hu-filter-color');
    if (nextProps.filter_type !== 'color')
      bg.className = bg.className.replace(/\sselected/g, '');
    else 
      bg.className = 'hu-filter-color' + ' selected';
    return false;
  }

  render() {
    const { filter_type } = this.props;
    const selected = filter_type === 'color';
    
    return (
      <div className={ selected ? 'hu-filter-color selected' : 'hu-filter-color' }></div>
    );
  }
}

export default FilterColor;


// WEBPACK FOOTER //
// ./app/js/components/filter/FilterColor.js